import React from "react";
import {TvSpinner, TvDiv, TvH5 } from "@trustvid/design-system";


const FullScreenLoader = ({loading, setLoading}) => {

  return (
        loading && (
        <TvDiv className="backdrop">
          <TvDiv className="loader-content">
            <TvSpinner color="light" style={{ width: "3rem", height: "3rem" }} />
            <TvH5 className="mt-3 text-light">please wait...</TvH5>
          </TvDiv>
        </TvDiv>
      )
  );
};

export default FullScreenLoader;
